<div
	class="modal fade"
	id="inactivityModal"
	tabindex="-1"
	aria-hidden="true"
	data-bs-backdrop="static"
	data-bs-keyboard="false"
>
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">{{ 'modals.inactivityModal.title' | translate }}</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>

			<div class="modal-body text-center">
				<p>
					{{ 'modals.inactivityModal.textSesion1' | translate }}
					<strong>{{ 'modals.inactivityModal.textSesion2' | translate }}</strong>
					{{ 'modals.inactivityModal.textSesion3' | translate }}
				</p>
				<p class="text-muted">{{ 'modals.inactivityModal.textSesion4' | translate }}{{ timer }}</p>
			</div>

			<div class="modal-footer">
				<button #dismiss class="btn btn-primary" (click)="restart()" data-bs-dismiss="modal">
					{{ 'modals.inactivityModal.button' | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
